import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { Navbar, Footer } from "@/components/shared";
import { site } from "@/config/site";

export default function NotFound() {
  return (
    <div data-testid="not-found-page">
      <Navbar />
      <main className="pt-header min-h-[70vh] flex flex-col items-center justify-center px-6 text-center">
        <p className="overline mb-4">Pagina non trovata</p>
        <h1 className="text-4xl md:text-5xl font-serif font-light text-primary">Non abbiamo trovato questa pagina</h1>
        <p className="mt-4 text-muted-foreground max-w-md">
          Può tornare alla home, aprire il preventivatore oppure chiamarci: siamo disponibili 24 ore su 24.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" className="inline-flex items-center gap-2 bg-primary text-primary-foreground font-semibold px-6 py-3 rounded-full">
            Torna alla home
          </Link>
          <Link to="/preventivo" className="inline-flex items-center gap-2 border border-border px-6 py-3 rounded-full text-primary">
            Preventivo <ArrowRight size={16} />
          </Link>
          <a href={`tel:${site.telefonoRaw}`} className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-primary">
            <Phone size={16} /> {site.telefono}
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}
